import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { JoinPage } from "./routes/join/JoinPage";
import { LoginPage } from "./routes/login/LoginPage";
import { NotesPage } from "./routes/present/NotesPage";
import { PresenterPage } from "./routes/present/PresenterPage";
import { StudioListPage } from "./routes/studio/StudioListPage";
import { StudioPage } from "./routes/studio/StudioPage";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/studio" replace />} />
        <Route path="/studio" element={<StudioListPage />} />
        <Route path="/studio/:deckId" element={<StudioPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/present/:deckId" element={<PresenterPage />} />
        <Route path="/present/:deckId/notes" element={<NotesPage />} />
        <Route path="/j" element={<JoinPage />} />
        <Route path="/j/:code" element={<JoinPage />} />
        <Route path="*" element={<p style={{ padding: 32 }}>Not found.</p>} />
      </Routes>
    </BrowserRouter>
  );
}
